import * as React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import {
  DescriptionField,
  DueDatePicker,
  ReminderSelector,
  SetAsExpectedClosingDateCheckbox,
  SetAsNextActionDateCheckbox,
  StartDatePicker,
  StatusField,
  SubjectField,
  TypeSelector,
} from '@user/features/Activity/components/ActivityForm/Fields'
import type { ENTITY_TYPES } from '@sales-center/common'
import { ActivityOwnerField } from './ActivityOwnerField'
import { OwnerCalendarScopeHint } from './OwnerCalendarScopeHint'
import type { OwnerOption } from './ActivityFormFields.types'

type Props = {
  salesTeamId: number
  ownerId?: string
  owners?: OwnerOption[]
  entityType: ENTITY_TYPES
  attachToSlot?: React.ReactNode
  canUpdate: boolean
  showExpectedClosingDate: boolean
  reminderDisabled: boolean
}

// SH-1428 calendar "Create Event" layout. Field order per spec: Type, Attach To,
// Subject, Owner, Status, Start, Due, Set-as-Next-Action-Date, Description,
// Reminder. The Attach-To picker is injected by the host via attachToSlot.
export function ActivityFormFieldsAttachMode(props: Props) {
  const {
    salesTeamId,
    ownerId,
    owners,
    entityType,
    attachToSlot,
    canUpdate,
    showExpectedClosingDate,
    reminderDisabled,
  } = props

  return (
    <Box>
      <Stack direction="column" p={0}>
        <Box>
          <TypeSelector />
        </Box>
        {attachToSlot ? <Box>{attachToSlot}</Box> : null}
        <Box>
          <SubjectField />
        </Box>
        <Box>
          <ActivityOwnerField
            salesTeamId={salesTeamId}
            ownerId={ownerId}
            owners={owners}
            entityType={entityType}
          />
          <OwnerCalendarScopeHint
            salesTeamId={salesTeamId}
            owners={owners}
            entityType={entityType}
          />
        </Box>
        <Box>
          <StatusField />
        </Box>
        <Box>
          <StartDatePicker />
        </Box>
        <Box>
          <DueDatePicker />
        </Box>
        <Box ml={1}>
          {canUpdate && (
            <>
              <SetAsNextActionDateCheckbox />
              {showExpectedClosingDate && <SetAsExpectedClosingDateCheckbox />}
            </>
          )}
        </Box>
        <Box>
          <DescriptionField mt={canUpdate ? 0 : 2} />
        </Box>
        <Box>
          <ReminderSelector disabled={reminderDisabled} />
        </Box>
      </Stack>
    </Box>
  )
}
